/** Session outcomes a provider can confirm; sent as the `status` body to confirm_outcome. Mirrors the backend derived-session-status catalog. */
export enum ProviderConfirmableStatus {
  RESCHEDULED = 'rescheduled',
  COMPLETED = 'completed',
  COMPLETED_OFF_PLATFORM = 'completed_off_platform',
  CLIENT_NO_SHOW = 'client_no_show'
}

/** A provider-confirmable status paired with its display label; the backend owns the label wording. */
export type ProviderConfirmableOutcome = {
  status: ProviderConfirmableStatus;
  label: string;
};

/** Fallback labels shown until the backend list loads. */
export const DEFAULT_PROVIDER_CONFIRMABLE_OUTCOMES: ProviderConfirmableOutcome[] = [
  { status: ProviderConfirmableStatus.RESCHEDULED, label: 'Rescheduled' },
  { status: ProviderConfirmableStatus.COMPLETED, label: 'Completed (SonderMind video)' },
  {
    status: ProviderConfirmableStatus.COMPLETED_OFF_PLATFORM,
    label: 'Completed (phone, in-person, or other video)'
  },
  { status: ProviderConfirmableStatus.CLIENT_NO_SHOW, label: 'Client no-show' }
];

/** One session's outcome the provider submits in the batched "what happened?" confirmation. */
export type ProviderOutcomeConfirmation = {
  id: number;
  status: ProviderConfirmableStatus;
};

/** How the backend settled one item of the batched confirmation (confirm_outcomes). */
export enum ProviderConfirmationResult {
  /** Recorded as the provider's answer. */
  CONFIRMED = 'confirmed',
  /** Settled elsewhere (a claim/admin override) since the queue loaded — dropped silently. */
  RESOLVED = 'resolved',
  /** An unexpected failure on this one session; the row is kept so the provider can retry. */
  ERROR = 'error'
}

/** The per-session result the batched confirm_outcomes endpoint returns for each submitted item. */
export type ProviderOutcomeConfirmationResult = {
  id: number;
  result: ProviderConfirmationResult;
};
